import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[app-narrow-sidebar-search]',
})
export class NarrowSidebarSearchDirective {
  // @HostBinding('type') type = 'search'; TODO check
  @HostBinding('class') class =
    'col-start-1 row-start-1 block size-full bg-white pl-8 text-base text-gray-900 outline-none outline-hidden placeholder:text-gray-400 sm:text-sm/6';
}
